export const CAC_SET_CONFIG = 'GCG/CAC_SET_CONFIG'
export const setCacConfig = (payload, meta, error = false) => ({
    type: CAC_SET_CONFIG,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SET_CARD_NETWORK = 'GCG/CAC_SET_CARD_NETWORK'
export const setCacCardNetwork = (payload, meta, error = false) => ({
    type: CAC_SET_CARD_NETWORK,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SET_AVAILABLE_CARD_NETWORKS =
    'GCG/CAC_SET_AVAILABLE_CARD_NETWORKS'
export const setCacAvailableCardNetworks = (payload, meta, error = false) => ({
    type: CAC_SET_AVAILABLE_CARD_NETWORKS,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SET_OCCASION_SLUG = 'GCG/CAC_SET_OCCASION_SLUG'
export const setCacOccasionSlug = (payload, meta, error = false) => ({
    type: CAC_SET_OCCASION_SLUG,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_UPDATE_CUSTOM_CARD = 'GCG/CAC_UPDATE_CUSTOM_CARD'
export const updateCustomCard = (payload, meta, error = false) => ({
    type: CAC_UPDATE_CUSTOM_CARD,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_EDIT_CARD_REQUESTED = 'GCG/CAC_EDIT_CARD_REQUESTED'
export const editCustomCardRequest = (payload, meta, error = false) => ({
    type: CAC_EDIT_CARD_REQUESTED,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_RESET_EDIT_CARD_REQUESTED = 'GCG/CAC_RESET_EDIT_CARD_REQUESTED'
export const resetEditCustomCardRequest = (payload, meta, error = false) => ({
    type: CAC_RESET_EDIT_CARD_REQUESTED,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_REMOVE_CARD_REQUESTED = 'GCG/CAC_REMOVE_CARD_REQUESTED'
export const removeCustomCardRequest = (payload, meta, error = false) => ({
    type: CAC_REMOVE_CARD_REQUESTED,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_RESET_CUSTOM_CARD = 'GCG/CAC_RESET_CUSTOM_CARD'
export const resetCustomCard = (payload, meta, error = false) => ({
    type: CAC_RESET_CUSTOM_CARD,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_RESET_APP_REQUESTED = 'GCG/CAC_RESET_APP_REQUESTED'
export const resetCacAppRequested = (payload, meta, error = false) => ({
    type: CAC_RESET_APP_REQUESTED,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_CLEAR_RESET_APP_REQUESTED = 'GCG/CAC_CLEAR_RESET_APP_REQUESTED'
export const clearResetCacAppRequest = (payload, meta, error = false) => ({
    type: CAC_CLEAR_RESET_APP_REQUESTED,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_RESET_APP = 'GCG/CAC_RESET_APP'
export const resetCacApp = (payload, meta, error = false) => ({
    type: CAC_RESET_APP,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_UPDATE_BACKGROUND = 'GCG/CAC_UPDATE_BACKGROUND'
export const updateCustomCardBackground = (payload, meta, error = false) => ({
    type: CAC_UPDATE_BACKGROUND,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_REQUEST_NEXT_STEP = 'GCG/CAC_REQUEST_NEXT_STEP'
export const requestNextStep = (payload, meta, error = false) => ({
    type: CAC_REQUEST_NEXT_STEP,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_ADD_TO_CART_REQUEST = 'GCG/CAC_ADD_TO_CART_REQUEST'
export const addToCartRequest = (payload, meta, error = false) => ({
    type: CAC_ADD_TO_CART_REQUEST,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SET_CART_ERRORS = 'GCG/CAC_SET_CART_ERRORS'
export const setCartErrors = (payload, meta, error = false) => ({
    type: CAC_SET_CART_ERRORS,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SET_ADDING_TO_CART = 'GCG/CAC_SET_ADDING_TO_CART'
export const setAddingToCart = (payload, meta, error = false) => ({
    type: CAC_SET_ADDING_TO_CART,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_ADD_CUSTOM_CARD = 'GCG/CAC_ADD_CUSTOM_CARD'
export const addCustomCard = (payload, meta, error = false) => ({
    type: CAC_ADD_CUSTOM_CARD,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_SAVE_CUSTOM_CARDS = 'GCG/CAC_SAVE_CUSTOM_CARDS'
export const saveCustomCards = (payload, meta, error = false) => ({
    type: CAC_SAVE_CUSTOM_CARDS,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_PRESET_CUSTOM_CARD = 'GCG/CAC_PRESET_CUSTOM_CARD'
export const presetCustomCard = (payload, meta, error = false) => ({
    type: CAC_PRESET_CUSTOM_CARD,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_DUPLICATE_CUSTOM_CARD = 'GCG/CAC_DUPLICATE_CUSTOM_CARD'
export const duplicateCustomCardRequest = (payload, meta, error = false) => ({
    type: CAC_DUPLICATE_CUSTOM_CARD,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_VALIDATE_ADDRESS_REQUEST = 'GCG/CAC_VALIDATE_ADDRESS_REQUEST'
export const validateCustomCardAddressRequest = (
    payload,
    meta,
    error = false
) => ({
    type: CAC_VALIDATE_ADDRESS_REQUEST,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_VALIDATE_ADDRESS_RESPONSE = 'GCG/CAC_VALIDATE_ADDRESS_RESPONSE'
export const validateCustomCardAddressResponse = (
    payload,
    meta,
    error = false
) => ({
    type: CAC_VALIDATE_ADDRESS_RESPONSE,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_ADDRESS_VALIDATION_RESULT = 'GCG/CAC_ADDRESS_VALIDATION_RESULT'
export const putCustomCardAddressValidationResult = (
    payload,
    meta,
    error = false
) => ({
    type: CAC_ADDRESS_VALIDATION_RESULT,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})

export const CAC_RESET_ADDRESS_VALIDATION_RESULT =
    'GCG/CAC_ADDRESS_VALIDATION_RESULT'
export const resetCustomCardAddressValidationResult = (
    payload,
    meta,
    error = false
) => ({
    type: CAC_RESET_ADDRESS_VALIDATION_RESULT,
    payload,
    ...(error && { error }),
    ...(meta && { meta }),
})
